import React, { useEffect, useState } from 'react';
import { IMainMadlenIntegrationProps } from '../../../../models/components/madlen-integrations';
import { useDispatch, useSelector } from 'react-redux';
import { GetAIContents } from '../../../../store/actions/madlenIntegration';
import { MadlenContentTypeEnums } from '../../../../models/enums/madlenContentType';
import { IAppState } from '../../../../models/action/core';
import CommonTable from '../commonTable/main';
import Loading from '../../../loading/loading';
import ContentLoader from 'react-content-loader';

const InProcessActivities: React.FC<IMainMadlenIntegrationProps> = ({ courseId, classId }) => {

    const dispatch = useDispatch();
    const inProcessActivities = useSelector((state: IAppState) => state.madlenIntegration.inProcessActivities)

    const [filters, setFilters] = useState({
        orderBy: "",
        query: '',
        page: 1,
        total: -1,
        take: 10,
    });

    useEffect(() => {
        getContents(filters);
    }, [filters]);

    const getContents = (filters: any) => {
        dispatch(
            GetAIContents(
                courseId ?? "",
                MadlenContentTypeEnums.Pending,
                filters.take,
                filters.page,
                false,
                filters.query,
                "getAIActivities",
                "get"
            )
        );
    };

    const onPageChange = (page: number) => {
        setFilters((prevFilters) => {
            return {
                ...prevFilters,
                page
            };
        });
    };

    return (
        <div>
            <Loading spinnerId={'getAIActivities'}>
                <div style={{ backgroundColor: '#eeede9', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <ContentLoader
                        speed={2}
                        width={1200}
                        height={600}
                        viewBox="0 0 1200 600"
                        backgroundColor="#d9d9d9"
                        foregroundColor="#ededed"
                    >
                        <rect x="2%" y="20" rx="4" ry="4" width="8%" height="30" />
                        <rect x="12%" y="20" rx="4" ry="4" width="25%" height="30" />
                        <rect x="40%" y="20" rx="4" ry="4" width="15%" height="30" />
                        <rect x="58%" y="20" rx="4" ry="4" width="20%" height="30" />
                        <rect x="80%" y="20" rx="4" ry="4" width="15%" height="30" />

                        {Array.from({ length: 10 }).map((_, index) => {
                            const yOffset = 70 + index * 50;
                            return (
                                <React.Fragment key={index}>
                                    <rect x="2%" y={yOffset} rx="4" ry="4" width="8%" height="40" />
                                    <rect x="12%" y={yOffset} rx="4" ry="4" width="25%" height="40" />
                                    <rect x="40%" y={yOffset} rx="4" ry="4" width="15%" height="40" />
                                    <rect x="58%" y={yOffset} rx="4" ry="4" width="20%" height="40" />
                                    <rect x="80%" y={yOffset} rx="4" ry="4" width="15%" height="40" />
                                </React.Fragment>
                            );
                        })}
                    </ContentLoader>
                </div>
            </Loading>
            <div className="col-12 page-table helpDesk-table p-0 m-t-0" id="getAIActivities_Content">
                <CommonTable activitiesData={inProcessActivities} onPageChange={onPageChange} />
            </div>
        </div>

    );
};

export default InProcessActivities;